export const types = {
  'JOB_SELECTED': 'JOB_SELECTED',
  'TODAY_SELECTED': 'TODAY_SELECTED',
  'TICKET_SELECTED': 'TICKET_SELECTED',
};
